import { useMemo } from 'react'

import { ImageSourceType } from '@/types/servicesTypes/configTypes'
import { FindImgByWidthOptionsType } from '@/types/utilsTypes'
import { findNearestByImgWidth } from '@/utils/utils'

export const useFindNearestByImgWidth = (
  sources: ImageSourceType[] | undefined,
  target: number,
  options?: FindImgByWidthOptionsType,
) => {
  return useMemo(
    () => sources && findNearestByImgWidth(sources, target, options),
    [sources],
  )
}
